var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "intro-container" }, [
    _c(
      "div",
      { staticClass: "flex font-18 text-000 intro-content" },
      [
        _c("el-image", { staticClass: "image", attrs: { src: _vm.introImg } }),
        _vm._m(0),
      ],
      1
    ),
    _c("div", { staticClass: "picture" }, [
      _c("div", { staticClass: "divv", staticStyle: { width: "30%" } }, [
        _c(
          "div",
          { staticClass: "item" },
          [
            _c("el-image", {
              staticClass: "el-image",
              staticStyle: { width: "100%" },
              attrs: { src: _vm.picture2, "preview-src-list": [_vm.picture2] },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "m-t-20 font-18 text-000 text-center",
            staticStyle: { height: "48px" },
          },
          [_vm._v("云南省高校人才市场人力资源服务许可证")]
        ),
      ]),
      _c("div", { staticClass: "divv", staticStyle: { width: "30%" } }, [
        _c(
          "div",
          { staticClass: "item" },
          [
            _c("el-image", {
              staticClass: "el-image",
              staticStyle: { width: "100%" },
              attrs: { src: _vm.picture3, "preview-src-list": [_vm.picture3] },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "m-t-20 font-18 text-000 text-center",
            staticStyle: { height: "48px" },
          },
          [_vm._v("云南省高校人才市场保密资质")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "flex-1", staticStyle: { "line-height": "36px" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "justify",
              "text-indent": "36px",
              "letter-spacing": "1px",
            },
          },
          [
            _vm._v(
              " 云南省高校人才市场，坐落于素以“春城”著称的昆明,隶属于云南大学，于1998年6月1 在昆明挂牌成立，迄今为止已经为客户提供了23年的优质服务，主要经营:为政府，企事业单位提供人才测评、考试服务，高等院校人才、科技人才等的咨询、培训、中介服务及相关经济、人才信息的交流、发布等。 "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "justify",
              "text-indent": "36px",
              "letter-spacing": "1px",
            },
          },
          [
            _vm._v(
              " 近年来严格的考务组织管理，强大的考试信息采集及数据处理能力，扩大了在业内外的影响，不断为政府指令性招考及各大国企、事业单位等提供了专业的考试考务服务工作。市场有云南省保密委核发的绝密级保密室，全员通过并取得保密工作证。配备了专业的考试管理和技术人员，拥有自主知识产权的题库系统、阅卷系统，拥有自己的命题、阅卷、考试基地和办公场所，考试技术指导为考试服务工作提供了强有力的保障。 "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "justify",
              "text-indent": "36px",
              "letter-spacing": "1px",
            },
          },
          [
            _vm._v(
              " 高校人才市场本着以服务用人部门、服务社会、服务考生为己任，以公开、公平、公正为基本原则，以实现科学考试、公平考试、安全考试为总目标，致力于加强命题技术、考务制度体系、考试信息化、考试文化等考试核心能力建设，较好地完成了数千科次的专业技术人员资格考试、数百万人员参加的遴选考试和事业单位公开招聘、以及烟草行业、公安系统、武警部队、军人事务厅、环保厅、教体局、文旅局、各产业园区、团（市、区、县）委等政府机构，各高校、企、事业单位的公开招聘工作人员、文职辅警、专项教师、村官、三支一扶、西部志愿者、社区工作者等考试工作，涉及覆盖面广泛，零失误高效率，专业的考务组织树立了云南省人事考试的品牌和权威。 "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "justify",
              "text-indent": "36px",
              "letter-spacing": "1px",
            },
          },
          [
            _vm._v(
              " 今后，我们仍将继续努力加强自身建设，努力加强考试新技术、新模式、新题型的研发，加强考试信息化建设，努力做好每一项考试，为人才队伍建设做出我们的贡献。 "
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }